







































import {
  Component,
  Vue,
  Watch,
  Prop,
  Emit,
  Model,
} from 'vue-property-decorator';

@Component
export default class Collapse extends Vue {
  // 启用折叠面板，只展示一个面板
  @Prop({ default: 0, required: false }) private name!: any;
  @Prop({ default: '', required: false }) private title!: any;
  @Prop({ default: false, required: false }) private disabled!: any;
  @Prop({ default: false, required: false }) private relation!: any;
  @Prop({ default: false, required: false }) private rightText!: any;
  // @Prop({ default: '', required: false }) private leftText!: any;

  private created() {
    // console.log(this.$slots.content);
    // console.log((document.querySelector('.panel') as any).innerHTML);
    // setTimeout(() => {
    //   console.log((document.getElementsByClassName('panel') as any));
    // }, 10);
    // console.log(typeof this.rightText);
    // console.log(typeof this.relation);
  }
}
